/**
 * 创建 html link 元素
 * @param {string} href - 链接
 * @returns {HTMLAnchorElement}
 */
const createHtmlLink = href => {
  const link = document.createElement('a');
  link.href = href;
  return link;
};

export default createHtmlLink;
